function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.5 60C117.5 91.4802 91.9802 117 60.5 117C29.0198 117 3.5 91.4802 3.5 60C3.5 28.5198 29.0198 3 60.5 3C91.9802 3 117.5 28.5198 117.5 60Z",
  stroke: "#00B056",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.235 28.2456C51.8461 34.5121 44.3095 46.1279 44.3095 52C44.3095 60.2843 51.0252 67 59.3095 67C67.5938 67 74.3095 60.2843 74.3095 52C74.3095 46.1279 66.7729 34.5121 62.384 28.2456C60.5812 25.6715 59.3095 24 59.3095 24C59.3095 24 58.0378 25.6715 56.235 28.2456ZM59.3095 62C64.8323 62 69.3095 57.5228 69.3095 52C69.3095 51.1086 68.8061 49.1829 67.4348 46.2445C66.152 43.4957 64.3972 40.4504 62.5766 37.5547C61.4545 35.7701 60.3293 34.0765 59.3095 32.5878C58.2897 34.0765 57.1645 35.7701 56.0424 37.5547C54.2218 40.4504 52.467 43.4957 51.1841 46.2445C49.8129 49.1829 49.3095 51.1086 49.3095 52C49.3095 57.5228 53.7867 62 59.3095 62Z",
  fill: "#00B056"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6124 66.7373L93.5722 68.3029L92.0065 79.2627L88.0468 78.6971L88.6207 74.6795L67.3095 91.5509L59.3095 85.2175L51.3095 91.5509L24.5 70.3267L26.9828 67.1905L51.3095 86.4491L56.0873 82.6667L40.5 70.3267L42.9828 67.1905L59.3095 80.1158L70.418 71.3215L66.0468 70.6971L66.6124 66.7373L77.5722 68.3029L76.0066 79.2627L72.0468 78.6971L72.6207 74.6795L62.5317 82.6667L67.3095 86.4491L86.418 71.3215L82.0468 70.6971L82.6124 66.7373Z",
  fill: "#00B056"
});

function SvgIglSpot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIglSpot);
export default __webpack_public_path__ + "static/media/IGLSpot.65b81669.svg";
export { ForwardRef as ReactComponent };